import { ThemeOptions } from '@mui/material';

export const DarkThemeOptions: ThemeOptions = {
  palette: {
    mode: 'dark',
    primary: {
      main: '#78909c',
      light: '#a7c0cd',
      dark: '#4b636e',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#9c8478',
      light: '#cdb4a7',
      dark: '#6d574c',
      contrastText: '#ffffff',
    },
    background: {
      default: '#1a1f22',
      paper: '#263238',
    },
    text: {
      primary: 'rgba(255,255,255,0.87)',
    },
    error: {
      main: '#f44336',
    },
  },
  typography: {
    h1: {
      fontWeight: 600,
    },
    h2: {
      fontSize: '4.4rem',
      fontWeight: 500,
    },
    fontFamily: 'Raleway',
  },
  shape: {
    borderRadius: 12,
  },
};
